<template>
  <div>
    <v-tooltip bottom open-delay="300">
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-icon
            size="25"
            :disabled="!motivos"
            @click="dialog_ativo = true"
          >
            $Notepad
          </v-icon>
        </div>
      </template>
      <span>Clique para ver a justificativa do ajuste sugerido pelo Systock.</span>
    </v-tooltip>

    <SysDialog
      v-model="dialog_ativo"
      max-width="800"
      content-class="bra-8"
      titulo="Observações"
      ocultar-acoes
    >
      <p class="mb-5 font-14 font-weight-bold text-black">
        {{ props.produto.idproduto }} - {{ props.produto.descricao_produto }}
      </p>

      <div v-for="(item, key) in props.motivos" :key="key" class="pb-2">
        <p class="mb-0 font-14 font-weight-medium text-black">{{ item.titulo }}</p>
        {{ item.mensagem }}
      </div>
    </SysDialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

const props = defineProps({
  motivos: {
    type: [Array, null],
    required: false
  },
  produto: {
    type: Object,
    required: true
  }
});

const dialog_ativo = ref(false);
</script>
